module.exports = __webpack_public_path__ + "static/media/Reliclogo.d5f071c8.png";